// 常用表情集 —— 按类目聚类(同类相邻),靠注释分组、不加可见分类标签(零 i18n 改动)。
// 选取跨平台通用、老系统也能正常渲染的常见字符;选中后由 EmojiPicker 直接拼到输入框。
// 兼容性基线:仅用到 Emoji 12.0(2019)及更早的字符,刻意不含 13.0+(2020+)新表情
// (如 🥲/🤌)—— 老系统(如 Win10 1909 的 Segoe UI Emoji)缺字会渲染成「豆腐块」□。
// web 客服与数字人客服共用本表(WebChatPanel / digital ChatPane 人工模式)。
export const EMOJIS = [
  // 笑脸 / 情绪
  '😀', '😃', '😄', '😁', '😆', '😅', '😂', '🤣', '😊', '😇', '🙂', '🙃', '😉', '😌', '😍', '🥰', '😘', '😗', '😚',
  '😋', '😛', '😝', '😜', '🤪', '🤨', '🧐', '🤓', '😎', '🥳', '😏', '😒', '😔', '😟', '🙁', '☹️', '😣', '😖', '😫', '😩',
  '🥺', '😢', '😭', '😤', '😠', '😡', '🤯', '😳', '🥵', '🥶', '😱', '😨', '😰', '😥', '😓', '🤗', '🤔', '🤭', '🤫', '🙄',
  '😶', '😐', '😑', '😬', '😮', '😲', '🥱', '😴', '🤤', '🤐', '🥴', '🤢', '🤮', '🤧', '😷', '🤒', '🤕',
  // 手势 / 人
  '👍', '👎', '👌', '✌️', '🤞', '🤟', '🤘', '🤙', '👈', '👉', '👆', '👇', '☝️', '✋', '🖐️', '🖖', '👋', '🤝', '🙏',
  '💪', '👏', '🙌', '👐', '🤲',
  // 心形 / 符号
  '❤️', '🧡', '💛', '💚', '💙', '💜', '🖤', '🤍', '🤎', '💔', '❣️', '💕', '💞', '💓', '💗', '💖', '💘', '💝', '✨', '⭐',
  '🌟', '💫', '💥', '💯', '🔥',
  // 动物 / 自然
  '🐶', '🐱', '🐭', '🐹', '🐰', '🦊', '🐻', '🐼', '🐨', '🐯', '🦁', '🐮', '🐷', '🐸', '🐵', '🌸', '🌺', '🌹', '🌻', '🍀',
  // 食物
  '🍎', '🍊', '🍋', '🍉', '🍇', '🍓', '🍑', '🍒', '🍔', '🍟', '🍕', '🍿', '🍩', '🎂', '🍦', '🍺', '☕',
  // 活动 / 物品
  '🎉', '🎊', '🎈', '🎁', '🎀', '⚽', '🏀', '🎮', '🎯', '🚀', '✈️', '🎵', '💡', '📌', '✅', '❌', '⭕', '❓', '❗',
];
